module.exports = __webpack_public_path__ + "static/media/country_bg.a8c6026b.webp";